/* eslint-disable */
var body = document.body,
  overlay = document.querySelector('.overlay'),
  overlayBtts = document.querySelectorAll('a[class*="open-overlay"]'),
  feloginHiddenDiv = document.querySelector('.felogin-hidden');

[].forEach.call(overlayBtts, function(btt) {
  btt.addEventListener('click', function() {
    var overlayOpen = this.classList.contains('open-overlay');
    overlay.setAttribute('aria-hidden', !overlayOpen);
    body.classList.toggle('noscroll', overlayOpen);

    if (this.hasAttribute('data-targeturl')) {
      var targetUrl = this.getAttribute('data-targeturl');

      // Erstellt ein neues input-Element mit dem Wert von targetUrl
      var hiddenInput = document.createElement('input');
      hiddenInput.setAttribute('type', 'hidden');
      hiddenInput.setAttribute('name', 'redirect_url');
      hiddenInput.setAttribute('value', targetUrl);
      feloginHiddenDiv.appendChild(hiddenInput);
    }
  }, false);

  document.querySelectorAll('.close-overlay').forEach(function(closeButton) {
    closeButton.addEventListener('click', function() {
      overlay.setAttribute('aria-hidden', true);
      body.classList.remove('noscroll');
    });
  });
});
/* eslint-enable */
